import { DailyFilter } from 'searchCards';
import { RefineClub } from 'searchCards/RefineClubs';
import {
  MatchInfoGroup,
  PlayerGroup,
  RefineTenGameAverageScore,
} from 'searchCards/nba/cardFilters';

export const scoutingCenterMarketFilters = [
  MatchInfoGroup,
  PlayerGroup({ withClub: true, withoutActiveClub: true }),
];

export const scoutingCenterMarketDropdownFilters = [
  RefineClub,
  DailyFilter,
  RefineTenGameAverageScore,
];
